import { makeStyles } from '@mui/styles'

const textField = {
  borderRadius: '12px',
  backgroundColor: '#f8f8ff',
  marginBottom: '8px',
  borderColor: '#000000',

  '& .MuiInputBase-input::placeholder': {
    color: 'black',
    fontSize: '1rem',
    fontWeight: '600'
  },
  '& .MuiInputLabel-root': {
    lineHeight: '16px',
    color: '#000000'
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#000000'
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    height: '51px',
    '& fieldset': {
      borderColor: '#000000'
    },
    '&:hover fieldset': {
      borderColor: '#000000'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#000000'
    }
  },
  '& .MuiOutlinedInput-root.Mui-error': {
    borderRadius: '12px',
    height: '51px',
    '& fieldset': {
      borderColor: 'red'
    },
    '&:hover fieldset': {
      borderColor: 'red'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'red'
    }
  },
  '& .MuiInputLabel-root.Mui-error': {
    lineHeight: '16px',
    color: 'red'
  },
  '& .MuiFormHelperText-root.Mui-error': {
    marginTop: '8px',
    marginBottom: '8px',
    fontSize: '16px',
    color: 'red',
    borderColor: 'red'
  },
  '& .MuiInputBase-input': {
    padding: '16px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    height: '1.2em'
  },
  'input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
  },
  'input:-webkit-autofill:hover': {
    WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
  },
  'input:-webkit-autofill:focus': {
    WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
  },
  'input:-webkit-autofill:active': {
    WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#F8F9FD',
    borderRadius: '10px',
    maxWidth: '393px',
    padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100%'
    },
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(3)} ${theme.spacing(6)}`
    }
  },
  terms: {
    background: '#F8F9FD',
    borderRadius: '10px',
    maxWidth: '393px',
    padding: `${theme.spacing(2)} 0`,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100%',
      marginTop: theme.spacing(2)
    },
    [theme.breakpoints.down('md')]: {
      padding: 0
    }
  },
  secured: {
    background: '#F8F9FD',
    borderRadius: '10px',
    maxWidth: '393px',
    padding: '0',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100%',
      marginTop: theme.spacing(2)
    },
    [theme.breakpoints.down('md')]: {
      padding: 0
    }
  },
  trialPrice: {
    color: '#8661C1',
    fontWeight: 'bold'
  },
  totalLabel: {
    fontWeight: 900,
    fontSize: 24,
    lineHeight: '24px'
  },
  promoText: {
    margin: '8px 0',
    color: 'green'
  },
  promoError: {
    color: 'red'
  },
  heading: {
    fontWeight: 700,
    fontSize: '11px',
    lineHeight: '24px',
    fontFamily: 'Red Hat Display',
    color: '#707070'
  },
  textField,
  promoTextField: {
    ...textField,
    marginTop: theme.spacing(0.5),
    '& .MuiInputBase-input': {
      padding: '16px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRight: '1px solid #000',
      height: '1.2em'
    }
  },
  button: {
    color: '#5D5BED',
    fontWeight: 'bold',
    textTransform: 'none',
    width: '100%',
    height: '100%',
    padding: '16.5px 14px',
    fontSize: '16px',
    cursor: 'pointer',
    '&:hover': {
      background: '#F8F9FD',
      width: '100%',
      height: '100%'
    }
  },
  summary: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(3)
    }
  }
}))

export default useStyles
